import { ButtonWithIcon } from "components/UI/ButtonWithIcon/ButtonWithIcon";

import chevron from "assets/images/chevron.svg";

import "./CoverflowView.scss";

const CoverflowView = ({
  slides,
  prevSlide,
  currentSlide,
  nextSlide,
  isMobile,
}) => {
  return (
    <div className={`carousel`}>
      <div className="carousel__slides">
        <div
          className="carousel__slide carousel__slide-left"
          style={{
            backgroundImage: `url(${slides[(currentSlide - 1 + slides.length) % slides.length].image})`,
          }}
        />
        <ButtonWithIcon
          className="carousel__button-prev coverflow"
          icon={chevron}
          onClick={prevSlide}
        />
        <div className="carousel__slide carousel__slide-wrapper">
          <div
            className="carousel__slide carousel__slide-wrapper-center"
            style={{
              backgroundImage: `url(${slides[currentSlide].image})`,
            }}
          />
        </div>
        <ButtonWithIcon
          className="carousel__button-next coverflow"
          icon={chevron}
          onClick={nextSlide}
        />
        <div
          className="carousel__slide carousel__slide-right"
          style={{
            backgroundImage: `url(${slides[(currentSlide + 1) % slides.length].image})`,
          }}
        />
      </div>

      <div className="carousel__caption">{slides[currentSlide].caption}</div>
      {isMobile && (
        <div className="carousel__buttons">
          <ButtonWithIcon
            className="carousel__button-prev"
            icon={chevron}
            onClick={prevSlide}
          />
          <ButtonWithIcon
            className="carousel__button-next"
            icon={chevron}
            onClick={nextSlide}
          />
        </div>
      )}
    </div>
  );
};

export default CoverflowView;
